module.exports = __webpack_public_path__ + "5fec409400acb31e906e1b6c074292b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-SemiBoldItalic.woff2
// module id = 1809
// module chunks = 1